module.exports = __webpack_public_path__ + "media/img/pages/companies/unistgallen-f01da0408d0c067d88ea97b41e4801cb.png";